// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue'
import Steps from './components/steps.vue'
import eventBus from './util/eventBus'


/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----init222', this.model.style, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update', this.model, props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
    }
  }

  const setHtml = (model, props) => {

    KDApi.loadFile('./css/index.css', model, () => {
      const { invoke, dom } = model
      const { data } = props
      const activeI = data ? data.avtiveIndex : -1
      new Vue({
        el: dom,
        template: '<Steps :invoke="invoke" :isOpening="isOpening" :isClosing="isClosing" :buildBeanList="buildBeanList" :isTransverse="isTransverse" :model="model" :getLangMsg="getLangMsg" :saleStatusBeanList="saleStatusBeanList"/>',
        components: {
          Steps
        },
        data: {
          activeIndex: activeI,
          model: model,
          buildBeanList:[],
          saleStatusBeanList:[],
          isTransverse:false,
          isOpening:false,
          isClosing:false
        },
        mounted() {
          const self = this
          this.updateSub = eventBus.sub(model, 'update', (props) => {
            
            console.log('props',props)
            const { data } = props 
            this.isOpening=false
            if(data.type=='opening_quotation'){
              console.log('点击放盘返回接口',props)
              this.isOpening=true
              return
           }
           this.isClosing=false
           if(data.type=='closing_quotation'){
            console.log('点击收盘盘返回接口',props)
            this.isClosing=true
            return
         }
            self.saleStatusBeanList = data ? data.saleStatusBeanList : []
            self.buildBeanList = data ? data.buildBeanList : []
            self.isTransverse=data ? data.isTransverse:false
            if( self.buildBeanList != undefined ||  self.buildBeanList.length > 0){

            // console.log('self.buildBeanList',self.buildBeanList)
            self.buildBeanList.forEach((i)=>{
              self.$set(i,'AllisSelect',false)
              if( i.buildHeadBean.unitBeanList != undefined || i.buildHeadBean.unitBeanList.length > 0){
                // console.log('i.buildHeadBean.unitBeanList',i.buildHeadBean.unitBeanList) 
              i.buildHeadBean.unitBeanList.forEach((ii)=>{
   
                if(ii.unitHoldBeanList.length==1&&ii.name.length>3&&ii.name.length<=6)
                {
                  self.$set(ii,'isMore',1)
                }else if(ii.unitHoldBeanList.length==1&&ii.name.length>6){
                  self.$set(ii,'isMore',2)
                }else{
                  self.$set(ii,'isMore',0)
                }
                if( ii.unitHoldBeanList != undefined || ii.unitHoldBeanList.length > 0){
                     ii.unitHoldBeanList.forEach((iii)=>{
                       self.$set(iii,'rolisSelect',false)
                  })
                }

           })
          }
          if( i.floorBeanList != undefined || i.floorBeanList.length > 0){
            // console.log('i.floorBeanList',i.floorBeanList) 
                 i.floorBeanList.forEach((ii)=>{
                  self.$set(ii,'colisSelect',false)
                  if( ii.unitBeanList != undefined ||  ii.unitBeanList.length > 0){
                    // console.log('ii.unitBeanList',ii.unitBeanList) 
                    ii.unitBeanList.forEach((iii)=>{

                      if(iii.roomBeanList.length==1&&iii.name.length>3&&iii.name.length<=6&&(iii.roomBeanList[0].roomSize==0||iii.roomBeanList[0].roomSize==1))
                        {
                          self.$set(iii,'isMore',1)
                        }else if(iii.roomBeanList.length==1&&iii.name.length>6&&(iii.roomBeanList[0].roomSize==0||iii.roomBeanList[0].roomSize==1)){
                          self.$set(iii,'isMore',2)
                        }else{
                          self.$set(iii,'isMore',0)
                        }
                        iii.roomBeanList.forEach((iiii)=>{
                          self.$set(iiii,'isSelect',false)
                        })
                    })
                  }
                 })
                }
            })  }
            console.log('buildBeanList',self.buildBeanList)
          })
        },
        destroyed() {
          eventBus.unsub(this.updateSub)
        },
        methods: {
          invoke: (eventName, args) => {
            invoke(eventName, args)
          },
          getLangMsg: (key) => {
            return KDApi.getLangMsg(model, key)
          }
        }
      })
    })
  }

  // 注册自定义组件
  KDApi.register('resalquotation', MyComponent, {
    isMulLang: true
  })
})(window.KDApi)
